import { combineReducers } from 'redux';
import authReducer, { AuthState } from './authReducer';
import zoneDetailsReducer from './zoneDetailsReducer';

import userReducer,{FormState} from './userReducer';
import healthBlockReducer from './healthBlockReducer';
import beneficiaryReducer, { BeneficiaryState } from './beneficiaryReducer';
import facilityGeoMapReducer, { GeometryEngineState } from './facilityGeoMapReducer';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; 
import eventExecutionReducer, { EventExecutionState } from './eventExecutionReducer';
import workPlanReducer, { WorkPlanState } from './workPlanReducer';
import facilityDashboardReducer, { DashboardState } from './facilityDashboardReducer'
import registerationReducer, { RegisterationState } from './registerationReducer';
import approvalReducer, { ApprovalState } from './approvalReducer';
import serviceRuleMasterReducer, { ServiceRuleMasterState } from './serviceRuleMasterReducer';
export interface RootState {
  auth: AuthState;
  user:FormState;
  beneficiary: BeneficiaryState;
  facilityGeoMap: GeometryEngineState;
  eventExution: EventExecutionState;
  workPlan: WorkPlanState;
  registeration:RegisterationState;
  facilityDashboard: DashboardState;
  approvalWorkFlow: ApprovalState;
  serviceRuleMaster: ServiceRuleMasterState;
}
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['beneficiary', 'eventExution', 'workPlan','registeration','facilityDashboard', 'approvalWorkFlow', 'serviceRuleMaster'],
  blacklist: ['auth', 'GeoNonGeoData', 'user', 'healthBlock', 'facilityGeoMap'],
};
 const rootReducer:any = combineReducers({
  auth: authReducer,
  GeoNonGeoData:zoneDetailsReducer,
  user:userReducer,
  healthBlock:healthBlockReducer,
  beneficiary:beneficiaryReducer,
  facilityGeoMap: facilityGeoMapReducer,
  eventExution: eventExecutionReducer,
  workPlan: workPlanReducer,
  facilityDashboard: facilityDashboardReducer,
  registeration:registerationReducer,
  approvalWorkFlow: approvalReducer,
  serviceRuleMaster: serviceRuleMasterReducer
});
export default persistReducer(persistConfig, rootReducer);

